import _ from 'lodash';
import React from 'react';
import uuid4 from 'uuid/v4';

import Table from 'components/Table';
import StatusBox from 'components/StatusBox';
import Paginator from 'components/Paginator';

import {AdminInformation} from './components';

import {headOption} from 'utils/common';
import {formatDateTime} from 'utils/datetime';

import './styles.css';

const ActionReportsTable = ({
  actionReports,
  statusOptions,
  pagination,
  onPageChange
}) => {
  const columnsMap = [
    {className: 'idColumn', heading: 'Id'},
    {className: 'adminColumn', heading: 'Admin'},
    {className: 'createdAtColumn', heading: 'Created At'},
    {className: 'statusColumn', heading: 'Status'},
    {className: 'actionColumn', heading: 'Action'},
    {className: 'linkColumn', heading: 'Link'},
    {className: 'errorMessageColumn', heading: 'Error message'},
    {className: 'keyColumn', heading: 'Key'}
  ];

  const calculateColor = actionReport => {
    return headOption(
      statusOptions.filter(st => st.value === actionReport.status),
      x => x.color
    );
  };
  return (
    <div className="ActionReportsTable">
      <div className="tableContainer">
        <div className="tableHeader">
          <Table>
            <Table.Header>
              {columnsMap.map(column => (
                <Table.HeaderItem
                  key={uuid4()}
                  className={column.className}
                  heading={column.heading}
                />
              ))}
            </Table.Header>
          </Table>
        </div>
        <div className="tableBody">
          <Table>
            <Table.Body>
              {actionReports.map(actionReport => (
                <Table.Row key={uuid4()}>
                  <Table.Cell className="idColumn">
                    {actionReport.id}
                  </Table.Cell>
                  <Table.Cell className="adminColumn">
                    {!_.isNil(actionReport.admin) && (
                      <AdminInformation admin={actionReport.admin} />
                    )}
                    {_.isNil(actionReport.admin) && 'System Call'}
                  </Table.Cell>
                  <Table.Cell className="createdAtColumn">
                    {formatDateTime(actionReport.createdAt)}
                  </Table.Cell>
                  <Table.Cell className="statusColumn">
                    <StatusBox
                      color={calculateColor(actionReport)}
                      status={actionReport.status}
                    />
                  </Table.Cell>
                  <Table.Cell className="actionColumn">
                    {actionReport.action}
                  </Table.Cell>
                  <Table.Cell className="linkColumn">
                    <a href={actionReport.detailLink}>
                      {actionReport.description}
                    </a>
                  </Table.Cell>
                  <Table.Cell className="errorMessageColumn">
                    {actionReport.errorMessage}
                  </Table.Cell>
                  <Table.Cell className="keyColumn">
                    {actionReport.key === '' && 'N/A'}
                    {actionReport.key !== '' && actionReport.key}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
        <Paginator pagination={pagination} onPageChange={onPageChange} />
      </div>
    </div>
  );
};

export default ActionReportsTable;
